import React from 'react'
import "./skills.css";
import { skillsData } from './Data';

const Skills = () => {
  return (
    <section className="skills section" id="skills">
        <h2 className="section_title">Skills</h2>
        <span className="section_subtitle">What I work with</span>
        <div className="skills_container container grid">
            {skillsData.map((group) => (
                <div className="skills_content" key={group.title}>
                    <h3 className="skills_title">{group.title}</h3>

                    <div className="skills_box">
                        <div className="skills_group">
                            {group.skills.map((skill) => (
                                <div className="skills_data" key={skill.name}>
                                    <i className="bx bx-badge-check"></i>
                                    <div>
                                        <h3 className="skills_name">{skill.name}</h3>
                                        <span className="skills_level">{skill.level}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </section>
  )
}

export default Skills
